import { registerSchedulerOfflineShell } from './platform/web/schedulerOfflineShell';
import './ui/diagnostics/consoleRecorder';
import './styles.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './ui/App';
import { ToastProvider } from './ui/components/common/ToastProvider';
import { Timestamp } from 'firebase/firestore';
import { registerChunkLoadRecovery } from './ui/diagnostics/chunkLoadRecovery';
import { markRuntimeEntrypoint, registerGlobalRuntimeErrorDiagnostics } from './ui/diagnostics/runtimeDiagnostics';

// FIX: Monkey-patch the Firebase Timestamp object to make it serializable.
// JSON.stringify will automatically call this toJSON method when it encounters a Timestamp.
// This prevents "Converting circular structure to JSON" errors that can occur with
// complex objects in state, especially with dev tools or some libraries.
(Timestamp.prototype as any).toJSON = function() {
  return this.toDate().toISOString();
};

// Register before React renders so stale lazy chunks from a just-replaced deployment
// can trigger a one-shot cache-busting navigation instead of leaving a blank screen.
registerChunkLoadRecovery();
void registerSchedulerOfflineShell();
markRuntimeEntrypoint('src/index.tsx');
registerGlobalRuntimeErrorDiagnostics();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </React.StrictMode>
);
